module.exports = __webpack_public_path__ + "img/img2.bf6d6625.svg";